import React, { Suspense, lazy } from 'react'

import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import { withStyles } from '@material-ui/core/styles'
import isNil from 'lodash/isNil'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import Loading from 'utils/Loading'
import { printUIOpen } from 'utils/Print/actions'
import Preview from 'utils/Print/Preview'

// ReactPDF relies on a 3rd party component called yoga-layout which is about 600KB.
// To avoid packaging with our core code we do lazy loading or code splitting.PrintAdvanced
// https://serverless-stack.com/chapters/code-splitting-in-create-react-app.html

const Sidebar = lazy(() => import('utils/Print/Sidebar'))
const Topbar = lazy(() => import('utils/Print/Topbar'))

const topBarHeight = 50

const styles = theme => ({
  root: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    zIndex: 10
  },
  paperOuter: {
    height: '100%'
  },
  gridOuter: {
    height: '100%'
  },
  gridTopbar: {
    height: topBarHeight,
    backgroundColor: '#424242'
  },
  gridSidebar: {
    height: 'calc(100% - ' + topBarHeight + 'px)'
  },
  gridDocument: {
    backgroundColor: '#a2a2a2',
    height: 'calc(100% - ' + topBarHeight + 'px)'
  },
  loading: {
    position: 'absolute',
    top: 60,
    left: '21%'
  }
})

class PrintAdvanced extends React.Component {
  componentDidMount () {
    // Capture CTRL + P to show print UI
    document.addEventListener('keydown', (evt) => {
      if (evt.ctrlKey && evt.code === 'KeyP') {
        this.props.printUIOpen()

        evt.preventDefault()
      }
    })
  }

  render () {
    const { classes, printUIVisible } = this.props

    // return null // handy for debugging legend/layers panel in print mode

    if (isNil(printUIVisible) || printUIVisible === false) {
      return null
    }

    return (
      <div className={classes.root}>
        <Paper className={classes.paperOuter}>
          <Grid className={classes.gridOuter} container>
            <Grid className={classes.gridTopbar} item xs={12}>
              <Suspense fallback={<div className={classes.loading}><Loading text="" /></div>}>
                <Topbar hideDownloadButton={false} />
              </Suspense>
            </Grid>
            <Grid className={classes.gridSidebar} item xs={3}>
              <Suspense fallback={null}>
                <Sidebar />
              </Suspense>
            </Grid>
            <Grid className={classes.gridDocument} item xs={9}>
              <Preview />
            </Grid>
          </Grid>
        </Paper>
      </div>
    )
  }
}

PrintAdvanced.propTypes = {
  classes: PropTypes.object.isRequired,
  printUIVisible: PropTypes.bool.isRequired,
  printUIOpen: PropTypes.func.isRequired
}

function mapStateToProps (state, ownProps) {
  return {
    printUIVisible: state.printUIVisible
  }
}

const mapDispatchToProps = dispatch => {
  return {
    printUIOpen: () => {
      dispatch(printUIOpen())
    }
  }
}

export default (
  withStyles(styles)(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(PrintAdvanced)
  )
)
